import KskBox from 'ksk/styledComponents/components/KskBox/KskBox';
import { px2em } from 'ksk/styledComponents/functions';
import { device } from 'ksk/styledComponents/mixins';
import styled, { css } from 'styled-components';

const StyledKskBox = styled(KskBox)` 
  max-width: ${px2em(900)};
  margin: 3em auto;

  .home__header {
    display: grid;
    grid-template-columns: -webkit-min-content 1fr;
    grid-template-columns: min-content 1fr;
    -webkit-box-align: center;
    align-items: center;
    grid-column-gap: 1em;                     
  }

  .home__logo-tesouro {
    width: ${px2em(110)};
    ${device.onlyPhone(css`
      width: ${px2em(75)};
    `)}
  }

  .home__apresentacao {
    font-weight: 300;
    text-align: left;
    margin: .25em 0;
  }

  .home__siconfi-small {
    font-weight: 300;
    font-size: 14px;
    text-align: left;
    margin: 0;
}

  h3 {
    text-align: center;
    margin: 1em;
    font-weight: 300;
  }

  .home__text-columns {
    text-align: justify;

    ${device.tablet(css`
      columns: ${px2em(150)} 2;
      column-gap: ${px2em(20)};
    `)}

    ${device.desktop(css`
      columns: ${px2em(150)} 3;
      column-gap: ${px2em(50)};
    `)}
  }

  .home__body {
    padding: 0 3em 3em;

  }
  
  // LEGACY FIX

  h3 {
    font-size: 20px;
  }

  p {
    font-size: revert;
    font-weight: revert;
    line-height: revert;
    margin-bottom: revert;
  }
`;

export const S = {
  KskBox: StyledKskBox
};